<app-navbar [title]="pageTitle">
	@if (editable) {
		<button class="btn btn-primary me-3" (click)="submit()">Zapisz</button>
	} @else {
		<button class="btn btn-primary me-3" (click)="editUnlock()">Edycja</button>
	}
	<a class="btn btn-danger" routerLink="../"> <i class="fas fa-chevron-left"></i> Powrót </a>
</app-navbar>

<div class="container my-4">
	<div class="form-floating mb-3">
		<mat-form-field class="w-100">
			<mat-label>Nazwa pierwszego członu tytułu sekcji</mat-label>
			<input
				matInput
				name="name"
				[(ngModel)]="data.name"
				[disabled]="!editable"
				placeholder="Przykładowo: LAST MINUTE"
			/>
		</mat-form-field>
	</div>
	<div class="form-floating mb-3">
		<mat-form-field class="w-100 ml-3">
			<mat-label>Nazwa drugiego członu tytułu sekcji</mat-label>
			<input
				matInput
				name="name"
				[(ngModel)]="data.nameSuffix"
				[disabled]="!editable"
				placeholder="Przykładowo: LAST MINUTE"
			/>
		</mat-form-field>
	</div>
	<div class="form-floating mb-3">
		<mat-form-field class="w-100">
			<mat-label for="kind">Typ:</mat-label>
			<mat-select id="kind" name="kind" [(ngModel)]="data.kind" [disabled]="!editable">
				<mat-option disabled>(wybierz)</mat-option>
				@for (item of service.kindSet; track item.name) {
					<mat-option [value]="item.value">{{ item.name }} </mat-option>
				}
			</mat-select>
		</mat-form-field>
	</div>
	<div class="form-floating mb-3">
		<mat-form-field class="w-100">
			<mat-label>URL</mat-label>
			<input
				matInput
				name="link"
				[(ngModel)]="data.link"
				[disabled]="!editable"
				placeholder="Przykładowo: https://oskar.com.pl/wakacje-autokarem/odpoczynek/chorwacja/autokarem"
			/>
		</mat-form-field>
	</div>
	<div class="form-floating mb-3">
		<mat-form-field class="w-100">
			<mat-label>Wybierz produkty</mat-label>
			<input
				type="text"
				matInput
				[disabled]="!editable"
				[matAutocomplete]="auto"
				(keyup)="search$.next($event.target.value)"
				placeholder="Wpisz min. 3 znaki, aby wyszukać..."
				[(ngModel)]="userInput"
			/>
			<mat-autocomplete #auto="matAutocomplete">
				@for (product of filteredProducts(); track product.id) {
					<mat-option (click)="selectProduct(product)">
						{{ product.name }}
					</mat-option>
				}
			</mat-autocomplete>
		</mat-form-field>
		<div>
			<h5 class="mt-3">Wybrane produkty:</h5>
			@if (isLoading()) {
				<div class="w-100 d-flex justify-content-center">
					<mat-progress-spinner color="primary" mode="indeterminate"></mat-progress-spinner>
				</div>
			} @else if (!isLoading() && !selectedProductIds().length) {
				<div class="w-100 d-flex justify-content-start">Brak wybranych produktów</div>
			} @else {
				<div class="d-flex flex-wrap gap-2">
					@for (product of selectedProductNames(); track product.id) {
						<div class="product-badge">
							<mat-chip (removed)="removeProduct(product.id)">
								{{ product.name }}
								<button matChipRemove [attr.aria-label]="'Usuń'">
									<i class="fas fa-close"></i>
								</button>
							</mat-chip>
						</div>
					}
				</div>
			}
		</div>
	</div>
	<div class="form-floating mb-3">
		<mat-checkbox [(ngModel)]="data.isActive" color="primary" [disabled]="!editable">Aktywna</mat-checkbox>
	</div>
</div>
